import { AVATAR_TYPES } from '../Constants';
const typeKeys = Object.keys(AVATAR_TYPES);
export const isType = value => {
  return typeof value === 'string' && typeKeys.includes(value);
};